import { render } from "./AdminSubCategories.vue?vue&type=template&id=0cb2436f&scoped=true"
import script from "./AdminSubCategories.vue?vue&type=script&lang=js"
export * from "./AdminSubCategories.vue?vue&type=script&lang=js"

import "./AdminSubCategories.vue?vue&type=style&index=0&id=0cb2436f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb2436f"]])

export default __exports__